import { Box } from '@mui/material'
import React from 'react'
import TotalGDPChart from './TotalGDPChart'

export default function GDP() {
  return (
    <>
      <Box>
        <TotalGDPChart />
      </Box>
    </>
  )
}
